import { Button, ButtonGroup, Dropdown, Header, Icon, Image, Popup } from "semantic-ui-react";
import { useAppDispatch } from "../../app/hooks";
import { ExportPng, ExportServer, ExportXml } from "./ExportActions";
import { AddItemToLabel, ClearAll, DeleteSelectedItem, NewLabel, SetZoomValue } from "../MainActions";
import { useEffect, useRef, useState } from "react";
import { ImportXml } from "./ImportXMLActions";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { ActionCreators as UndoActionCreators } from "redux-undo";
import { IItem } from "../../interfaces/Item";
import { PreviewModal } from "../PreviewModal/PreviewModal";
import { HORIZONTAL_LINE, VERTICAL_LINE } from "../../utils/ItemTypes";
import { useControls } from "react-zoom-pan-pinch";
import logo from "../../Ll.png";
import { zoomOptions } from "../../utils/constants";
import { Link, useNavigate } from "react-router-dom";
import { ImportModal } from "./ImportTemplatesModal";
import { GetAllTemplates } from "../CompanyDataTables/TablesActions";
import { TemplateNameModal } from "./TemplateNameModal";
import { FillDataModal } from "../FillDataModal/FillDataModal";
import { useTranslation } from "react-i18next";
import { LanguageSelector } from "./LanguageSelector";
import { ProfileMenu } from "./ProfileMenu";
import { ChangeSelectedCompany } from "../Auth/AuthActions";
interface Props {
  setZoom: (i: number) => void;
  panDisabled: boolean;
  setPanDisabled: (i: boolean) => void;
  showLogin: () => void;
}
export const HeaderBar = ({ setZoom, setPanDisabled, panDisabled, showLogin }: Props) => {
  const dispatch = useAppDispatch();
  const { templateName } = useSelector((state: RootState) => state.refData);
  const { labelItems, labelParams } = useSelector((state: RootState) => state.labelEdit.present);
  const { isAuthenticated, companyId, role, companyName, rights } = useSelector((state: RootState) => state.auth);
  const inputFile = useRef<HTMLInputElement>(null);
  const canUndo = useSelector((state: RootState) => state.labelEdit.past.length > 0);
  const canRedo = useSelector((state: RootState) => state.labelEdit.future.length > 0);
  const [openPreview, setOpenPreview] = useState(false);
  const [previewPng, setPreviewPng] = useState<Blob | null>();
  const { resetTransform, instance, setTransform } = useControls();
  const [importModalOpen, setImportModalOpen] = useState({ open: false, fromNewBtn: false });
  const [templateNameModalOpen, setTemplateNameModalOpen] = useState(false);
  const [fillDataModalOpen, setFillDataModalOpen] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const rightsOptions = rights.map((company) => {
    return { key: company.companyId, text: company.companyName, value: company.companyId };
  });
  const [selectedCompany, setSelectedCompany] = useState(companyId);
  const handleDropdownChange = async (e: any, data: any) => {
    await dispatch(ChangeSelectedCompany(data.value)).then(() => {
      setSelectedCompany(data.value);
    });
  };
  const handleImportXML = (e: any) => {
    setZoom(0);
    dispatch(ClearAll());
    dispatch(UndoActionCreators.clearHistory());
    resetTransform();
    dispatch(SetZoomValue(1));
    const file = e.target.files[0];
    dispatch(ImportXml(file));
    e.target.value = "";
    if (importModalOpen && isAuthenticated) {
      setImportModalOpen({ open: false, fromNewBtn: false });
    }
  };
  const onExportXml = async () => {
    setZoom(0);
    dispatch(ExportXml());
  };
  const onExportPng = async () => {
    dispatch(ExportPng()).then((blob: Blob | null) => {
      setPreviewPng(blob);
      setOpenPreview(true);
    });
  };

  const closePreviewModal = () => {
    setOpenPreview(false);
    setPreviewPng(null);
  };

  const handleUndo = () => {
    setZoom(0);
    dispatch(UndoActionCreators.undo());
  };
  const handleRedo = () => {
    setZoom(0);
    dispatch(UndoActionCreators.redo());
  };
  const handleNewLabel = () => {
    setZoom(0);
    resetTransform();
    dispatch(NewLabel());
    dispatch(UndoActionCreators.clearHistory());
    if (importModalOpen) {
      setImportModalOpen({ open: false, fromNewBtn: false });
    }
  };

  const handleNewLabelModal = () => {
    dispatch(GetAllTemplates(-1)).then(() => {
      setImportModalOpen({ open: true, fromNewBtn: true });
    });
  };
  const generateNewId = () => {
    return Math.floor(Number((labelItems.length + 1).toString() + (Math.random() * 100000000).toString()));
  };
  const handleDeleteItem = () => {
    dispatch(DeleteSelectedItem());
    setZoom(0);
  };
  const handleDuplicateItem = () => {
    const selectedItem = labelItems.find((item: IItem) => item.selected);
    if (selectedItem) {
      setZoom(0);
      if (selectedItem.type !== HORIZONTAL_LINE && selectedItem.type !== VERTICAL_LINE) {
        const newItem: IItem = {
          ...selectedItem,
          itemid: generateNewId(),
          selected: false,
          xInMM: selectedItem.xInMM + 5,
          yInMM: selectedItem.yInMM + 5,
          style: {
            ...selectedItem.style,
            top: `${(selectedItem.yInMM + 5) * labelParams.pxInMM}px`,
            left: `${(selectedItem.xInMM + 5) * labelParams.pxInMM}px`,
          },
        };
        dispatch(AddItemToLabel(newItem));
      } else {
        const newItem: IItem = {
          ...selectedItem,
          itemid: generateNewId(),
          selected: false,
          xInMM: selectedItem.xInMM + 5 || 5,
          yInMM: selectedItem.yInMM + 5 || 5,
          xToInMM: selectedItem.xToInMM! + 5 || 5,
          yToInMM: selectedItem.yToInMM! + 5 || 5,
          style: {
            ...selectedItem.style,
            top: `${(selectedItem.yInMM + 5) * labelParams.pxInMM}px`,
            left: `${(selectedItem.xInMM + 5) * labelParams.pxInMM}px`,
          },
        };
        dispatch(AddItemToLabel(newItem));
      }
    }
  };

  const onServerExport = () => {
    setZoom(0);
    dispatch(ExportServer());
  };
  const openImport = () => {
    dispatch(GetAllTemplates(companyId)).then(() => {
      setImportModalOpen({ open: true, fromNewBtn: false });
    });
  };

  useEffect(() => {
    if (window.location.pathname === "/") {
      const sessionVisited = sessionStorage.getItem("visited");
      if (!sessionVisited) {
        sessionStorage.setItem("visited", "true");
        handleNewLabelModal();
      }
    }
  }, []);

  return (
    <>
      <TemplateNameModal open={templateNameModalOpen} onClose={() => setTemplateNameModalOpen(false)} />
      <ImportModal open={importModalOpen.open} onClose={() => setImportModalOpen({ open: false, fromNewBtn: false })} handleImportXML={handleImportXML} fromNewBtn={importModalOpen.fromNewBtn} handleNewLabel={handleNewLabel} />
      <PreviewModal previewPng={previewPng} open={openPreview} onClose={closePreviewModal} />
      {isAuthenticated /*&& role === "super_admin"*/ && <FillDataModal open={fillDataModalOpen} onClose={() => setFillDataModalOpen(false)} />}
      <div className="headerContainer">
        <div className="header-button-gr" style={{minWidth: "450px"}}>
          <Link to="/">
            <Header as="h3">
              <Image src={logo} size="medium" verticalAlign="middle" />
            </Header>
          </Link>

          <Button basic color="blue" size="small" compact style={{ marginLeft: 10 }} onClick={handleNewLabelModal}>
            <Icon name="plus" />
            {t("new")}
          </Button>
          {!isAuthenticated ? (
            <Button
              basic
              color="blue"
              size="small"
              compact
              style={{ marginLeft: 5 }}
              onClick={() => {
                inputFile.current?.click();
              }}
            >
              <Icon name="upload" />
              {t("import_xml")}
              <input style={{ display: "none" }} type="file" ref={inputFile} onChange={handleImportXML} />
            </Button>
          ) : (
            <Button basic color="blue" size="small" compact style={{ marginLeft: 5 }} onClick={openImport}>
              <Icon name="upload" />
              {t("open_btn")}
            </Button>
          )}
          {templateName && templateName !== "" && 
            <span style={{fontWeight: 600, background: "#f5f5f7", borderRadius: "6px", padding: "6px 10px", marginLeft: 10, maxWidth: "200px", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis"}}>{templateName}</span>
          }
        </div>

        <ButtonGroup basic size="small" compact color="black" className="header-button-gr">
          <Popup content={t("undo")} position="bottom center" trigger={<Button icon="undo alternate" compact disabled={!canUndo} onClick={handleUndo} />} />
          <Popup content={t("redo")} position="bottom center" trigger={<Button  icon="redo alternate" compact disabled={!canRedo} onClick={handleRedo} />} />
          <Popup content={t("duplicate_item")} position="bottom center" trigger={<Button  icon="copy outline" compact onClick={handleDuplicateItem} />} />
          <Popup content={t("delete_item")} position="bottom center" trigger={<Button compact icon="trash alternate outline" onClick={handleDeleteItem} />} />
          <Button style={{ padding: "7.6px 9px 7.6px 9px" }} size="small">
            <Dropdown
              compact
              style={{ height: "1em"}}
              fluid
              placeholder="zoom"
              value={labelParams.zoom}
              options={zoomOptions}
              onChange={(e, { value }) => {
                setTransform(0, 0, value as number);
                dispatch(SetZoomValue(value as number));
              }}
            />
          </Button>
          <Popup
            content={t("zoom_in")}
            position="bottom center"
            trigger={
              <Button
                size="small"
                compact
                basic
                icon="zoom in"
                onClick={() => {
                  dispatch(SetZoomValue((instance.transformState.scale + 0.25) as number));
                  setTransform(0, 0, instance.transformState.scale + 0.25, 0);
                }}
              />
            }
          />
          <Popup
            content={t("zoom_out")}
            position="bottom center"
            trigger={
              <Button
                size="small"
                compact
                basic
                icon="zoom out"
                onClick={() => {
                  dispatch(SetZoomValue(instance.transformState.scale - 0.25));
                  setTransform(0, 0, instance.transformState.scale - 0.25, 0);
                }}
              />
            }
          />
          <Popup content={t("pan")} position="bottom center" trigger={<Button size="small" compact icon={panDisabled ? "hand paper outline" : "hand rock"} onClick={() => setPanDisabled(!panDisabled)} />} />
          <Popup
            content={t("reset_zoom")}
            position="bottom center"
            trigger={
              <Button
                size="small"
                compact
                basic
                icon="expand"
                onClick={() => {
                  resetTransform();
                  dispatch(SetZoomValue(1));
                }}
              />
            }
          />
        </ButtonGroup>
        <div className="header-button-gr">
          {isAuthenticated /*&& role === "super_admin"*/ && (
            <Button size="small" basic compact style={{ marginLeft: 5, marginRight: 5 }} onClick={() => setFillDataModalOpen(true)} color="black">
              <Icon name="tags" color="black" />
              {t("fill_data")}
            </Button>
          )}
          <ButtonGroup basic color="green" size="small" compact >
            <Dropdown text={t("save")} size="small" button basic className="icon header-btn" floating compact labeled icon="download">
              <Dropdown.Menu>
                <Dropdown.Item onClick={onExportXml}>
                  <Icon color="green" name="download" />
                  XML
                </Dropdown.Item>
                <Dropdown.Item onClick={onExportPng}>
                  <Icon color="green" name="print" />
                  PNG
                </Dropdown.Item>
                {isAuthenticated && ( //&& (role === "admin" || role === "super_admin") 
                  <>
                    <Dropdown.Item onClick={onServerExport}>
                      <Icon color="green" name="save" />
                      {t("server")}
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => setTemplateNameModalOpen(true)}>
                      <Icon color="green" name="server" />
                      {t("server_custom_name")}
                    </Dropdown.Item>
                  </>
                )}
              </Dropdown.Menu>
            </Dropdown>
          </ButtonGroup>
          {!isAuthenticated ? (
            <>
              <Button size="small" basic compact style={{ marginLeft: 10 }} onClick={showLogin}>
                <Icon name="user circle outline" color="black" />
                {t("login")}
              </Button>
              <LanguageSelector isAuthed={false} />
              <Popup content={t("user_manual")} position="bottom right" trigger={<Button compact basic icon="info circle" style={{ marginLeft: 3 }} onClick={() => navigate("/user-manual")} />} />
            </>
          ) : (
            <>
              <ButtonGroup size="small" color="blue" basic style={{ marginLeft: 10 }}>
                <Dropdown button text={companyName} compact fluid className="header-btn" floating options={rightsOptions} value={selectedCompany} onChange={handleDropdownChange} />
              </ButtonGroup>
              <ButtonGroup style={{ marginLeft: 5 }} basic size="small">
                <ProfileMenu />
              </ButtonGroup>
            </>
          )}
        </div>
      </div>
    </>
  );
};
